<template>
  <div class="flex flex-col items-center justify-center h-screen px-4">
    <img
      src="https://storage.googleapis.com/komerce/assets/logo/logo-komerce-no-tag.svg"
      alt="logo"
      width="176px"
      class="mb-[40px]"
    >
    <h1 class="text-2xl font-semibold text-center text-red-500 mb-[16px]">
      Integrasi Marketplace Gagal
    </h1>
    <p class="text-sm text-gray-500 text-center mb-[24px] max-w-[500px]">
      Maaf, integrasi tidak dapat dilanjutkan. Hal ini dapat terjadi karena kendala sistem atau akun marketplace ini telah digunakan oleh pengguna lain. Silakan coba kembali, gunakan akun yang belum terhubung, atau hubungi kami kalau butuh bantuan.
    </p>
    <p class="text-sm text-gray-500 text-center mb-[24px] max-w-[500px]">
      *Anda dapat menutup halaman ini untuk kembali ke halaman sebelumnya.
    </p>
    <div class="flex flex-wrap items-center justify-center gap-3">
      <button
        class="btn btn-primary px-[16px] py-[8px] bg-primary text-white hover:bg-primary-dark transition cursor-pointer"
        @click="handleBackToIntegration"
      >
        Kembali
      </button>
      <a
        href="https://wa.me/6281325862737"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button class="btn btn-outline-primary px-[16px] py-[8px] border border-primary text-primary hover:bg-primary hover:text-white transition cursor-pointer">
          Hubungi Customer Support
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorIntegrationPage',
  methods: {
    /**
     * Check if running in a popup window vs a full browser tab.
     * @returns {boolean}
     */
    isPopupWindow() {
      if (typeof window === 'undefined') return false

      if (!window.opener || window.opener === window || window.opener.closed) {
        return false
      }

      // Check for hidden browser chrome (typical of popups)
      const hasHiddenChrome = Boolean(
        (window.toolbar && !window.toolbar.visible)
        || (window.menubar && !window.menubar.visible)
        || (window.locationbar && !window.locationbar.visible)
        || (window.personalbar && !window.personalbar.visible),
      )
      if (hasHiddenChrome) return true

      // Check if window size is noticeably smaller than available screen
      const isSmallerThanScreen = (
        (window.outerWidth && window.outerWidth < window.screen.availWidth * 0.9)
        || (window.outerHeight && window.outerHeight < window.screen.availHeight * 0.9)
      )
      if (isSmallerThanScreen) return true

      return false
    },
    /**
     * Broadcast failure and close popup or redirect tab to integration page.
     */
    handleBackToIntegration() {
      const isChildWindow = this.isPopupWindow()

      try {
        const bc = new BroadcastChannel('marketplace_integration')
        bc.postMessage({
          type: 'INTEGRATION_FAILED',
          data: {
            source: isChildWindow ? 'popup' : 'tab',
          },
        })
        bc.close()
      } catch (e) {
        console.error('BroadcastChannel error:', e)
      }

      if (isChildWindow) {
        try {
          window.close()
        } catch (e) {
          this.$router.replace({ name: 'integrasi-marketplace' })
        }
      } else {
        this.$router.replace({ name: 'integrasi-marketplace' })
      }
    },
  },
}
</script>
